export default {
  getUserId: (state) => state.user.id || state.userId,
  getToken: (state) => state.token,
  getUser: (state) => state.user,
  getProfile: (state) => state.profile,
};
